import { PrivateApi } from '.';

class PrivateApiWithRouteLeavingCancelation extends PrivateApi {
    async getWithAbortControl<T>(endpoint: string, settings?: any): Promise<T> {
        const abortController = new AbortController();
        const signal = abortController.signal;
        const currentPathBeforeApiCall = window.location.pathname;

        function abortRequestOnNavigationClickRouteChange(): void {
            if (getRouteChanged(currentPathBeforeApiCall)) {
                document.removeEventListener('click', abortRequestOnNavigationClickRouteChange);
                abortController.abort();
            }
        }

        document.addEventListener('click', abortRequestOnNavigationClickRouteChange);
        const toReturn = await this.get<T>(endpoint, { ...(settings || {}), signal });
        document.removeEventListener('click', abortRequestOnNavigationClickRouteChange);
        return toReturn;
    }

    async postWithAbortControlOnCustomEvent<T>(
        endpoint: string,
        data: any = {},
        settings: Record<string, any> & { customEventName: string },
        expectNoResponse?: boolean,
    ): Promise<T> {
        const { customEventName, ...restSettings } = settings;
        const abortController = new AbortController();
        const signal = abortController.signal;

        function abortRequestOnCustomEvent(): void {
            if (customEventName) {
                document.removeEventListener(customEventName, abortRequestOnCustomEvent);
                abortController.abort();
            }
        }

        if (customEventName) document.addEventListener(customEventName, abortRequestOnCustomEvent);
        const toReturn = await this.post<T>(endpoint, data, { ...(restSettings || {}), signal }, expectNoResponse);
        if (customEventName) document.removeEventListener(customEventName, abortRequestOnCustomEvent);
        return toReturn;
    }

    async putWithAbortControlOnCustomEvent<T>(
        endpoint: string,
        data: any = {},
        settings: Record<string, any> & { customEventName: string },
        expectNoResponse?: boolean,
    ): Promise<T> {
        const { customEventName, ...restSettings } = settings;
        const abortController = new AbortController();
        const signal = abortController.signal;

        function abortRequestOnCustomEvent(): void {
            if (customEventName) {
                document.removeEventListener(customEventName, abortRequestOnCustomEvent);
                abortController.abort();
            }
        }

        if (customEventName) document.addEventListener(customEventName, abortRequestOnCustomEvent);
        const toReturn = await this.put<T>(endpoint, data, { ...(restSettings || {}), signal }, expectNoResponse);
        if (customEventName) document.removeEventListener(customEventName, abortRequestOnCustomEvent);
        return toReturn;
    }
}

export const privateApiWithRouteLeavingCancelation = new PrivateApiWithRouteLeavingCancelation();

const getRouteChanged = (path: string): boolean => path !== window.location.pathname;
